module.exports = __webpack_public_path__ + "files/6467678147ef0b35051df0fed4e722c0.png";